import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicActionsRoutingModule } from './public-actions-routing.module';



@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        PublicActionsRoutingModule
    ]
})
export class PublicActionsModule { }
